module.exports = __webpack_public_path__ + "img/avatar6.6cbd6135.png";